module.exports = __webpack_public_path__ + "img/code.7db25c51.png";